declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_localized_prop_value_foo extends $mol_object {
		bar( ): ({ 
			'loc': string,
			'baz': ({ 
				'loc2': string,
			}) ,
		}) 
	}
	
}

//# sourceMappingURL=structural_localized_prop_value.view.tree.d.ts.map